import { render, staticRenderFns } from "./CreateEditIntegration.vue?vue&type=template&id=8afb4856"
import script from "./CreateEditIntegration.vue?vue&type=script&lang=js"
export * from "./CreateEditIntegration.vue?vue&type=script&lang=js"
import style0 from "./CreateEditIntegration.vue?vue&type=style&index=0&id=8afb4856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports